<app-video-shot-asset
  [clip]="clip"
  [hidden]="hidden"
  [resourceProps]="{ playOnHover: true }" />
@if (!hidden) {
  @switch (clip.value.asset.state) {
    @case ('ready') {
      <p-speeddial
        [model]="filteredActions"
        direction="right"
        [style]="{
          position: 'absolute',
          left: '0.5rem',
          top: '0.5rem',
        }">
        <ng-template #button let-toggleCallback="toggleCallback">
          <p-button
            rounded
            severity="contrast"
            icon="pi pi-ellipsis-v"
            aria-label="Toggle Video Clip Menu"
            (onClick)="toggleCallback($event)" />
        </ng-template>
      </p-speeddial>
    }
    @case ('error') {
      <div class="absolute top-0 left-0 p-1">
        <p-button
          text
          rounded
          severity="danger"
          icon="pi pi-trash"
          ariaLabel="Delete Video Clip"
          (onClick)="onDeleteClick()" />
      </div>
    }
  }
}
